import { atom, selector } from 'recoil'
import { MESSAGE_BOX_VARIANT_DANGER } from 'mailup-web-components'

import {
  TRUSTED_SENDER_STATUS_CONFIRMED,
  TRUSTED_SENDER_STATUS_DELIVER_OK,
  TRUSTED_SENDER_STATUS_DELIVER_WARN,
  TRUSTED_SENDER_STATUS_DELIVER_ERROR,
  TRUSTED_SENDER_STATUS_NO_DELIVER,
  TRUSTED_SENDER_STATUS_DELIVER_ISP
} from 'Api/beSendGoApi'

import { trustedEmailSenderState } from 'Hooks/useTrustedEmailSender'

import { PECPLUS_STATUS_COMPLETE_DESCR } from 'Constants'

export const ACTUAL_VIEW_RECIPIENTS = 0
export const ACTUAL_VIEW_GROUPS = 1
export const MAX_EMAIL = 10

export const pageState = atom({
  key: 'QuickSendPageState',
  default: {
    loading: true,
    loaded: false,
    error: false,
    severity: 'danger',
    pecPlusStatus: undefined,
    messageErrors: false,
    subject: undefined,
    notes: undefined,
    preHeader: undefined,
    messageType: undefined,
    isBee: undefined,
    senderName: undefined,
    senderEmail: undefined,
    replyToEmail: undefined,
    bouncedEmail: undefined,
    fetchedSender: false,
    invalidReplyTo: false,
    sendResponse: undefined,
    verifyResponse: undefined,
    showVerifyResponse: false,
    senderIsDeleted: false,
    waitForVerified: false
  }
})

const validSenderStatus = [
  TRUSTED_SENDER_STATUS_CONFIRMED,
  TRUSTED_SENDER_STATUS_NO_DELIVER,
  TRUSTED_SENDER_STATUS_DELIVER_OK,
  TRUSTED_SENDER_STATUS_DELIVER_ERROR,
  TRUSTED_SENDER_STATUS_DELIVER_WARN,
  TRUSTED_SENDER_STATUS_DELIVER_ISP
]

export const isValidFormState = selector({
  key: 'QuickSendEnableValidForm',
  get: ({ get }) => {
    const {
      pecPlusStatus,
      senderEmail,
      senderName,
      replyToEmail,
      invalidReplyTo
    } = get(pageState)
    const { emailAddress, emailAddresses, check, actualView } = get(
      recipientsState
    )
    const { group } = get(selectState)

    let notEmptyField = false
    if (actualView === ACTUAL_VIEW_RECIPIENTS) {
      if (check) {
        notEmptyField = emailAddresses.length > 0 || emailAddress !== ''
      } else {
        notEmptyField = emailAddresses.length > 0 || emailAddress !== ''
      }
    } else {
      notEmptyField = group !== undefined
    }

    const { status: senderStatus } = get(
      trustedEmailSenderState('trustedSenderQuick')
    )

    const isPECPlus = !!pecPlusStatus

    const validSender = isPECPlus
      ? pecPlusStatus === PECPLUS_STATUS_COMPLETE_DESCR
      : validSenderStatus.includes(senderStatus)

    return (
      !!senderEmail &&
      !!senderName &&
      senderName !== '' &&
      validSender &&
      !!replyToEmail &&
      !invalidReplyTo &&
      notEmptyField
    )
  }
})

export const recipientsState = atom({
  key: 'QuickSendRecipientsState',
  default: {
    loading: false,
    loaded: false,
    error: false,
    severity: MESSAGE_BOX_VARIANT_DANGER,
    group: undefined, // deve essere selezionato se check === true
    emailAddresses: [],
    emailAddress: '', // campo input email/s
    actualView: ACTUAL_VIEW_RECIPIENTS,
    check: false // se check è true il gruppo deve essere selezionato
  }
})

export const selectState = atom({
  key: 'QuickSendSelectState',
  default: {
    group: undefined
  }
})

export const smallGroupsState = atom({
  key: 'QuickSendSmallGroupsState',
  default: []
})

export const smallGroupsLoadingState = atom({
  key: 'QuickSendSmallGroupsLoadingState',
  default: {
    loading: false,
    loaded: false,
    error: false
  }
})

export const addToGroupsState = atom({
  key: 'QuickSendAddToGroupsState',
  default: []
})

export const addToGroupsLoadingState = atom({
  key: 'QuickSendAddToGroupsLoadingState',
  default: {
    loading: false,
    loaded: false,
    error: false
  }
})
